export default __webpack_public_path__ + "static/media/close_blue.4bfc2cc8.svg";